<template>
  <v-expansion-panel-content
    ref="serviceSelectionStep"
    class="process-step-header"
    :disabled="disabled"
    :aria-disabled="disabled"
  >
    <div slot="header">
      <div class="flex">
        <div class="process-number">{{processNumber}}</div>
        <div class="process-step-name">{{messages.chooseServiceStep}}</div>
      </div>
      <div v-if="displaySelectedServiceInfo" class="chosen-options" aria-hidden="true">
        <small v-for="(selectedService, index) in selectedServices" :key="index">
          <div>{{servicesTranslations[selectedService.publicId] && servicesTranslations[selectedService.publicId].names[selectedLanguage.lang] ? servicesTranslations[selectedService.publicId].names[selectedLanguage.lang] : selectedService.name}}{{configuration.multiplePeopleEnabled ? ': ' + selectedService.adult + ' ' + messages.chooseServiceContentAdults + ', ' + selectedService.child + ' ' + messages.chooseServiceContentChildren  : ''}}</div>
        </small>
      </div>
    </div>
    <v-card>
      <v-card-text v-if="noServiceResultFromBackendServiceGroup" class="info-text" tabindex="0">{{messages.chooseServiceContentTextNoServices}}</v-card-text>
      <v-card-text v-else class="info-text" tabindex="0">{{messages.chooseServiceContentText}}</v-card-text>
      <v-progress-linear
        role="progressbar"
        v-if="loadingState"
        class="progress-bar"
        indeterminate
      ></v-progress-linear>
      <div v-else>
        <v-expansion-panel class="services-wrapper" v-if="checkShowServiceGroups" v-model="serviceGroupPanel">
          <v-expansion-panel-content
            class="service-expansion-panel"
            :expand-icon="'keyboard_arrow_down'"
            v-for="(serviceGroup, index) in serviceGroups"
            :key="index"
            aria-multiselectable="true"
            :id="'serviceGroup' + (index + 1)"
          >
            <div slot="header" class="flex">{{!serviceGroup.names[selectedLanguage.lang] || serviceGroup.names[selectedLanguage.lang] === "" ? serviceGroup.id : serviceGroup.names[selectedLanguage.lang]}}</div>
            <div v-if="checkExpand()">
              <service-card-check-box
                :checkedServices="checkedServices"
                :services="serviceGroup.services"
                :readOnlyCheckBoxes="readOnlyCheckBoxes"
                :maxPeopleAllowed="maxPeopleAllowed"
                :maxAdultsAllowed="maxAdultsAllowed"
                :maxChildrenAllowed="maxChildrenAllowed"
                @update-checked-services= 'updateCheckedServices'
                @remove-checked-service= 'removeCheckedService'
              ></service-card-check-box>
            </div>
            <div v-else>
              <service-card-radio
                :checkedServices="checkedServices"
                :services="serviceGroup.services"
                :maxPeopleAllowed="maxPeopleAllowed"
                :maxAdultsAllowed="maxAdultsAllowed"
                :maxChildrenAllowed="maxChildrenAllowed"
                @update-checked-services= 'updateCheckedServices'
              ></service-card-radio>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <div v-if="!checkShowServiceGroups">
          <div v-if="checkExpand()">
            <service-card-check-box
              :checkedServices="checkedServices"
              :services="services"
              :readOnlyCheckBoxes="readOnlyCheckBoxes"
              :maxPeopleAllowed="maxPeopleAllowed"
              :maxAdultsAllowed="maxAdultsAllowed"
              :maxChildrenAllowed="maxChildrenAllowed"
              @update-checked-services= 'updateCheckedServices'
              @remove-checked-service= 'removeCheckedService'
            ></service-card-check-box>
          </div>
          <div v-else>
            <service-card-radio
              :checkedServices="checkedServices"
              :services="services"
              :maxPeopleAllowed="maxPeopleAllowed"
              :maxAdultsAllowed="maxAdultsAllowed"
              :maxChildrenAllowed="maxChildrenAllowed"
              @update-checked-services= 'updateCheckedServices'
            ></service-card-radio>
          </div>
        </div>
      </div>
    </v-card>
  </v-expansion-panel-content>
</template>

<script>
import RestService from '../services/restService'
import DataService from '../services/dataService'
import ServiceCardRadio from './ServiceCardRadio'
import ServiceCardCheckBox from './ServiceCardCheckBox'
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
import { eventHub } from '../utils/eventhub'

export default {
  name: 'ServiceSelection',
  props: [
    'isFirst',
    'disabled',
    'processNumber'
  ],
  mixins: [RestService, DataService],
  components: { ServiceCardRadio, ServiceCardCheckBox },
  data: () => ({
    stepExpanded: false,
    services: [],
    serviceGroups: [],
    checkedServices: [],
    radioService: {},
    servicePanel: [],
    serviceGroupPanel: [],
    displaySelectedServiceInfo: false,
    maxPeopleAllowed: null,
    maxAdultsAllowed: null,
    maxChildrenAllowed: null,
    initPreselect: false,
    readOnlyCheckBoxes: false,
    selectedRadioService: '',
    noServiceResultFromBackendServiceGroup: false,
    appointmentProfiles: []
  }),
  computed: {
    ...mapState([
      'funcDebug',
      'configuration',
      'selectedServices',
      'selectedBranch',
      'isBranchStepValid',
      'servicesTranslations',
      'preSelectedServices',
      'messages',
      'selectedLanguage',
      'preSelectedServiceGroups'
    ]),
    ...mapGetters({
      totalCost: 'selectedServicesTotalCost',
      isServicesPreselected: 'isServicesPreselected',
      isServiceGroupsPreselected: 'isServiceGroupsPreselected'
    }),
    checkServicePrice () {
      return this.configuration.pricesEnabled && this.configuration.priceCalc === 'servicesPrice'
    },
    checkShowServiceGroups: function () {
      return (this.configuration.showServiceGroups && this.serviceGroups.length > 1) || (this.isServiceGroupsPreselected && this.serviceGroups.length > 1)
    },
    loadingState () {
      return this.services.length === 0 && !this.noServiceResultFromBackendServiceGroup
    }
  },
  watch: {
    checkedServices: {
      handler (newValue, oldValue) {
        if (this.funcDebug) console.log('ServiceSelection:watch:checkedServices')
        if (this.checkedServices.length > 0) {
          // ********************************************
          // GP-2280 crimar
          if (this.configuration.multipleServicesEnabled) {
            var appointmentProfilesResponse = this.appointmentProfiles
            // If multiple services are enable, check if services belong to the same appointment profile of calendar
            if ((appointmentProfilesResponse.status === 200) && (appointmentProfilesResponse.data != null)) {
              // var checkedServicesMapInit = this.checkedServices.map(function (e) { return e.publicId })
              var checkedServicesMap = this.checkedServices.map(function (e) { return e.publicId })
              var servicesToUpdate = []

              // Loop all appointmentProfiles
              for (var n = 0; n < appointmentProfilesResponse.data.length; n++) {
                // check if the appointment is for the selected branch or no branch is selected because serviceFirst
                if (this.configuration.serviceFirst || (appointmentProfilesResponse.data[n].branchPublicId === this.selectedBranch.id)) {
                  var serviceGroups = appointmentProfilesResponse.data[n].serviceGroups
                  for (var m = 0; m < serviceGroups.length; m++) {
                    var servicesInGroupMap = serviceGroups[m].services.map(function (e) { return e.publicId })
                    // If the service group has the checked services, update the info of services (enable or disable them)
                    if (checkedServicesMap.every(el => servicesInGroupMap.indexOf(el) > -1)) {
                      // save in servicesToUpdate the services of the valid servicesInGroupMap
                      servicesInGroupMap.forEach(elementInGroup => {
                        if (servicesToUpdate.indexOf(elementInGroup) === -1) {
                          servicesToUpdate.push(elementInGroup)
                        }
                      })
                    }
                  }
                }
              }

              // Disable or enable all the services with the previous calculation
              this.services.forEach(element => {
                if (servicesToUpdate.indexOf(element.publicId) === -1) {
                  element.isInAppointmentProfile = false
                } else {
                  element.isInAppointmentProfile = true
                }
              })
            }
          }
          // ********************************************
          for (var i = 0; i < this.checkedServices.length; i++) {
            var service = this.checkedServices[i]

            if (this.configuration.multiplePeopleEnabled) {
              if (this.initPreselect) {
                // add 1 adult in each
                service.adult = 1
                service.child = 0
                if (service.custom.cost && this.checkServicePrice) {
                  service.totalCost = service.custom.cost['adult'].default
                } else {
                  service.totalCost = 0
                }
                service.totalPeople = 1
                service.customLength = service.duration
              }
            }
          }
          this.setSelectedServices(this.checkedServices)
          this.initPreselect = false
          this.displaySelectedServiceInfo = true
          // check validation
          this.checkServicesValidity()
          this.$emit('data-selected', 'services')
        } else {
          // ///////////////////////////////////////
          // GP-2280 crimar
          // If multiple services are enable, reset services, all should be enabled
          if (this.configuration.multipleServicesEnabled) {
            this.services.forEach(element => {
              element.isInAppointmentProfile = true
            })
          }
          // ///////////////////////////////////////
          // check validation
          this.setSelectedServices(this.checkedServices)
          this.checkServicesValidity()
          this.$emit('check-steps')
        }
      },
      deep: true
    },
    radioService: {
      handler (newValue, oldValue) {
        if (this.funcDebug) console.log('ServiceSelection:watch:radioService')
        if (this.radioService.constructor === Object) {
          this.resetSelectedServices()
        }
        this.setSelectedServices([this.radioService])
        this.initPreselect = false
        this.displaySelectedServiceInfo = true
        // check validation
        this.checkServicesValidity()
        this.$emit('data-selected', 'services')
      },
      deep: true
    },
    selectedBranch (newValue, oldValue) {
      if (this.funcDebug) console.log('ServiceSelection:watch:selectedBranch')
      var _this = this
      if (!this.isFirst && this.isBranchStepValid) {
        if (!this.isServicesPreselected) {
          this.resetSelectedServices()
          this.checkedServices = []
          this.services = []
          if (this.configuration.showServiceGroups) {
            this.getServiceGroupsByBranch(this.selectedBranch.id).then(response => {
              if (this.funcDebug) console.log('ServiceSelection:watch:selectedBranch:getServiceGroupsByBranch.then')
              _this.serviceGroups = _this.filterServiceGroups(response.data)
              _this.loadServiceGroupsTranslations(_this.serviceGroups)
            })
          } else {
            this.getServicesByBranch(this.selectedBranch.id).then(response => {
              if (this.funcDebug) console.log('ServiceSelection:watch:selectedBranch:getServicesByBranch.then')
              _this.loadServicesTranslations(response.data)
            })
          }
        } else {
          this.fetchServiceList()
        }
        // check validation
        this.checkServicesValidity()
        this.$emit('check-steps')
      }
    }
  },
  methods: {
    ...mapActions([
      'addSelectedService',
      'setSelectedServices',
      'resetSelectedServices',
      'checkServicesValidity'
    ]),
    ...mapMutations([
      'setServicesTranslations'
    ]),
    checkExpand () {
      return this.configuration.multipleServicesEnabled || this.isServicesPreselected
    },
    updateCheckedServices (services) {
      this.checkedServices = [...services]
      this.displaySelectedServiceInfo = true
      this.setSelectedServices(this.checkedServices)
      this.checkServicesValidity()
      this.$emit('data-selected', 'services')
    },
    removeCheckedService (service) {
      var checkedServiceIndex = this.getByValue(this.checkedServices, service.publicId)
      if (typeof (checkedServiceIndex) !== 'undefined' && checkedServiceIndex !== null) {
        this.checkedServices.splice(checkedServiceIndex, 1)
        this.setSelectedServices(this.checkedServices)
        this.checkServicesValidity()
        this.$emit('data-selected', 'services')
      }
    },
    // fill properties on services array at mounting of when first step data loaded
    addServicesProperties (serviceData) {
      if (this.funcDebug) console.log('ServiceSelection:methods:addServicesProperties')
      var _this = this
      this.services = []
      var tempServicesTranslations = {}
      this.checkedServices = []
      var service
      var custom
      for (var j = 0; j < serviceData.length; j++) {
        service = serviceData[j]
        service.child = 0
        if (this.configuration.multiplePeopleEnabled) {
          service.adult = 0
          service.totalPeople = 0
          service.customLength = 0
        } else {
          // put 1 adult in each
          service.adult = 1
          service.totalPeople = 1
          service.customLength = service.duration
        }
        service.index = j
        if (service.custom) {
          custom = service.custom
          if (this.checkServicePrice) {
            if (custom.cost) {
              if (custom.cost.adult && custom.cost.adult.default && custom.cost.adult.default.length > 0) { custom.cost.adult.default = parseInt(custom.cost.adult.default) } else { custom.cost.adult.default = 0 }
              if (custom.cost.child && custom.cost.child.default && custom.cost.child.default.length > 0) { custom.cost.child.default = parseInt(custom.cost.child.default) } else { custom.cost.child.default = 0 }
              if (this.configuration.multiplePeopleEnabled) {
                service.totalCost = 0
              } else {
                service.totalCost = custom.cost.adult.default
              }
            } else {
              custom.cost = {}
              custom.cost.adult = {}
              custom.cost.child = {}
              custom.cost.adult.default = 0
              custom.cost.child.default = 0
            }
          }
          service.custom = custom
          tempServicesTranslations[service.publicId] = {}
          tempServicesTranslations[service.publicId].names = service.custom.names
        } else {
          custom = {}
          custom.names = {}
          custom.cost = {}
          custom.cost.adult = {}
          custom.cost.child = {}
          custom.cost.adult.default = 0
          custom.cost.child.default = 0
        }
        // ///////////////////////////////////////
        // GP-2280 crimar
        if (this.configuration.multipleServicesEnabled) {
          service.isInAppointmentProfile = true
        }
        // ///////////////////////////////////////
        this.services.push(service)
      }
      _this.setServicesTranslations(tempServicesTranslations)
    },
    addServiceGroupsProperties (serviceGroupData) {
      if (this.funcDebug) console.log('ServiceSelection:methods:addServiceGroupsProperties')
      var _this = this
      this.services = []
      var tempServicesTranslations = {}
      this.checkedServices = []
      var service
      var custom
      for (var i = 0; i < serviceGroupData.length; i++) {
        var serviceGroup = serviceGroupData[i]
        for (var k = 0; k < serviceGroup.services.length; k++) {
          service = serviceGroup.services[k]
          service.child = 0
          if (this.configuration.multiplePeopleEnabled && !this.isServicesPreselected) {
            service.adult = 0
            service.totalPeople = 0
            service.customLength = 0
          } else {
            // put 1 adult in each
            service.adult = 1
            service.totalPeople = 1
            service.customLength = service.duration
          }
          service.index = k
          if (service.custom) {
            custom = service.custom
            if (this.checkServicePrice) {
              if (custom.cost) {
                if (custom.cost.adult && custom.cost.adult.default && custom.cost.adult.default.length > 0) { custom.cost.adult.default = parseInt(custom.cost.adult.default) } else { custom.cost.adult.default = 0 }
                if (custom.cost.child && custom.cost.child.default && custom.cost.child.default.length > 0) { custom.cost.child.default = parseInt(custom.cost.child.default) } else { custom.cost.child.default = 0 }
                if (this.configuration.multiplePeopleEnabled) {
                  service.totalCost = 0
                } else {
                  service.totalCost = custom.cost.adult.default
                }
              } else {
                custom.cost = {}
                custom.cost.adult = {}
                custom.cost.child = {}
                custom.cost.adult.default = 0
                custom.cost.child.default = 0
              }
            }
            service.custom = custom
            tempServicesTranslations[service.publicId] = {}
            tempServicesTranslations[service.publicId].names = service.custom.names
          } else {
            custom = {}
            custom.names = {}
            custom.cost = {}
            custom.cost.adult = {}
            custom.cost.child = {}
            custom.cost.adult.default = 0
            custom.cost.child.default = 0
          }
          // ///////////////////////////////////////
          // GP-2280 crimar
          if (this.configuration.multipleServicesEnabled) {
            service.isInAppointmentProfile = true
          }
          // ///////////////////////////////////////
          serviceGroup.services[k] = service
          this.services.push(service)
          if (this.isServicesPreselected) {
            var found = false
            for (var l = 0; l < this.checkedServices.length; l++) {
              if (this.checkedServices[l].publicId === service.publicId) { found = true }
            }
            if (!found) { this.checkedServices.push(service) }
          }
        }
      }
      if (this.services.length === 0) this.noServiceResultFromBackendServiceGroup = true
      _this.setServicesTranslations(tempServicesTranslations)
    },
    loadServicesTranslations (serviceData) {
      if (this.funcDebug) console.log('ServiceSelection:methods:loadServicesTranslations')
      var _this = this
      var tempserviceTranslations = {}
      _this.getServiceNames(serviceData)
      for (let k = 0; k < serviceData.length; k++) {
        const service = serviceData[k]
        tempserviceTranslations[service.internalId] = {}
        tempserviceTranslations[service.internalId].names = service.custom.names
      }
      _this.setServicesTranslations(tempserviceTranslations)
      _this.addServicesProperties(serviceData)
    },
    loadServiceGroupsTranslations (serviceGroupData) {
      if (this.funcDebug) console.log('ServiceSelection:methods:loadServiceGroupsTranslations')
      var _this = this
      var tempserviceTranslations = {}
      for (let l = 0; l < serviceGroupData.length; l++) {
        const serviceGroup = serviceGroupData[l]
        _this.getServiceNames(serviceGroup.services)
        for (let k = 0; k < serviceGroup.services.length; k++) {
          const service = serviceGroup.services[k]
          tempserviceTranslations[service.internalId] = {}
          tempserviceTranslations[service.internalId].names = service.custom.names
        }
      }
      _this.setServicesTranslations(tempserviceTranslations)
      _this.addServiceGroupsProperties(serviceGroupData)
    },
    getServiceNames (data) {
      if (this.funcDebug) console.log('ServiceSelection:methods:getServiceNames')
      for (let k = 0; k < data.length; k++) {
        const service = data[k]
        if (service.custom) {
          service.custom = JSON.parse(service.custom)
        } else {
          service.custom = {}
          service.custom.names = {}
        }
      }
      if (this.$route.name === 'branchbooking' || this.$route.name === 'branchandservicegroupsbooking') {
        // this is the last unique action when branche is preselected
        this.$emit('is-loaded')
      }
      return data
    },
    fetchServiceList () {
      if (this.funcDebug) console.log('ServiceSelection:method:fetchServiceList')
      var _this = this
      if (this.configuration.showServiceGroups) {
        this.getServiceGroups().then(response => {
          if (this.funcDebug) console.log('ServiceSelection:methods:fetchServiceList:getServiceGroups.then')
          let serviceGroups = response.data // .filter(region => region.branches.length > 0)
          _this.serviceGroups = _this.filterServiceGroups(serviceGroups)
          _this.loadServiceGroupsTranslations(_this.serviceGroups)
        })
      } else {
        this.getServices().then(response => {
          if (this.funcDebug) console.log('ServiceSelection:method:fetchServiceList:getServices.then')
          // filter service to show only preselected services
          if (_this.isServicesPreselected) {
            var array = response.data.filter(service => _this.preSelectedServices.includes(service.publicId))
            _this.loadServicesTranslations(array)
            // check all services
            _this.checkedServices = [...array]
            // open all panels
            for (var i = 0; i < array.length; i++) {
              _this.servicePanel[i] = true
            }
            _this.servicePanel = [..._this.servicePanel]
          } else {
            _this.loadServicesTranslations(response.data)
          }
        })
      }
    },
    // params
    // array: serviceGroup
    filterServiceGroups (array) {
      if (this.funcDebug) console.log('ServiceSelection:methods:filterServiceGroups')
      var filteredServiceGroups = []
      for (let i = 0; i < array.length; i++) {
        var serviceGroup = array[i]
        if (this.isServiceGroupsPreselected) {
          if (!this.preSelectedServiceGroups.includes(serviceGroup.id)) { continue }
        }
        if (this.isServicesPreselected) {
          // currently never go there (keep the code in case of behavior change for preselection)
          var services = serviceGroup.services
          var filteredServices = services.filter(service => this.preSelectedServices.includes(service.publicId))
          serviceGroup.services = filteredServices
          if (filteredServices.length > 0) {
            filteredServiceGroups.push(serviceGroup)
          }
        } else {
          filteredServiceGroups.push(serviceGroup)
        }
      }
      return filteredServiceGroups
    },
    setfocus () {
      var _this = this
      this.$nextTick(() => {
        _this.$refs.serviceSelectionStep.$el.focus()
      })
    }
  },
  mounted () {
    if (this.funcDebug) console.log('ServiceSelection:mounted')
    eventHub.$on('service-step-focus', this.setfocus)
    if (this.isServicesPreselected) {
      this.initPreselect = true
      this.readOnlyCheckBoxes = true
    }
    if (this.isFirst) {
      this.fetchServiceList()
    }
    if (this.configuration.multiplePeopleEnabled) {
      this.maxPeopleAllowed = parseInt(this.configuration.maxTotal)
      this.maxAdultsAllowed = parseInt(this.configuration.maxAdults)
      this.maxChildrenAllowed = parseInt(this.configuration.maxChildren)
    }
    this.getAppointmentProfiles().then(value => {
      this.appointmentProfiles = value
    })
  }
}
</script>

<style scoped>
.amount-of .v-btn {
  min-width: 50px;
  margin: 0;
  min-height: 50px;
  padding: 0;
}
.amount-of .v-btn.v-btn--flat:focus {
  background-color: var(--defined-focused-element) !important;
}

.amount-of .number {
  min-width: 50px;
  border-top: 2px solid var(--primary-btn-bg-color) !important;
  border-bottom: 2px solid var(--primary-btn-bg-color) !important;
  line-height: 46px;
  font-weight: 500;
  text-align: center;
  font-size: 18px;
}

.radio-container {
  width: 100%;
}

.services-wrapper .v-expansion-panel__container.service-expansion-panel{
  flex: none;
  background-color: var(--input-selection-bg-color);
  border: solid 1px var(--default-border-color) !important;
  margin-top:4px;
  margin-bottom:4px;
  width: 100%;
}

.v-input--radio-group--column .v-radio:not(:last-child):not(:only-child){
  margin-bottom: 0px
}

.services-wrapper.v-expansion-panel{
  -webkit-box-shadow: none;
  box-shadow: none;
}
</style>
